import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerProfileFacade } from './customer-profile.facade';
import { CustomerProfile } from '@models/resources/customer-profile.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante (Sprint 5 Story S5-2). Active when
 * `environment.dataSource === 'http'`.
 *
 * Wire-Contract: `GET /api/me/customer` → flat `CustomerProfile` JSON.
 * The backend disables `JsonResource` wrapping globally
 * (`AppServiceProvider::boot()` calls `JsonResource::withoutWrapping()`),
 * so the response is the resource array directly.
 */
@Injectable()
export class HttpCustomerProfileFacade implements CustomerProfileFacade {
  private readonly http = inject(HttpClient);

  getProfile(): Observable<CustomerProfile> {
    return this.http.get<CustomerProfile>(`${environment.apiUrl}/me/customer`);
  }
}
